(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('DOMContentLoaded', function () {
      var forms = document.querySelectorAll('.contact-form__form');
      forms.forEach(function (form) {
        var tsInput = form.querySelector('input[name="contact[note_ts]"]');
        var loadTime = Date.now();
        if (tsInput) tsInput.value = loadTime;

        form.addEventListener('submit', function (e) {
          // 检测 honeypot 是否被填写
          var hp = form.querySelector('input[name="contact[company_name]"]');
          if (hp && hp.value.length > 0) {
            e.preventDefault();
            return false;
          }
          // 检测是否在3秒内提交
          if (Date.now() - loadTime < 3000) {
            e.preventDefault();
            return false;
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
